<template>
  <div class="auth">
    <NavBar />
    <h3>{{ t('forgot-title') }}</h3>

    <form v-if="!id" novalidate @submit.prevent="send">
      <label>{{ t('field-email') }}<input v-model="email" type="email" name="email" autocomplete="email" /></label>
      <p v-if="error" class="warn">{{ error }}</p>
      <button type="submit" :disabled="busy">{{ t('button-send-code') }}</button>
    </form>

    <div v-else-if="done">
      <p class="info">{{ t('reset-done') }}</p>
      <router-link :to="{ name: 'signin' }">{{ t('home-sign-in-link') }}</router-link>
    </div>

    <div v-else-if="expired">
      <p class="warn">{{ t('reset-expired') }}</p>
      <router-link :to="{ name: 'forgot-password' }" @click.native="reset">{{ t('button-send-code') }}</router-link>
    </div>

    <form v-else novalidate @submit.prevent="setPassword">
      <p v-if="sent" class="info">{{ t('forgot-code-sent') }}</p>
      <label>{{ t('field-code') }}<input v-model="code" name="code" inputmode="numeric" autocomplete="one-time-code" /></label>
      <label>{{ t('field-new-password') }}<input v-model="password" type="password" name="password" autocomplete="new-password" /></label>
      <label>{{ t('field-password-again') }}<input v-model="password2" type="password" name="password2" autocomplete="new-password" /></label>
      <p v-if="error" class="warn">{{ error }}</p>
      <button type="submit" :disabled="busy">{{ t('button-set-password') }}</button>
    </form>
  </div>
</template>

<script>
import NavBar from './NavBar';
import auth from '@/auth';
import { t, errorText } from '@/texts';

export default {
  name: 'ForgotPasswordPage',
  components: { NavBar },
  data() {
    return {
      email: '', password: '', password2: '',
      id: this.$route.query.id || null,
      code: this.$route.query.code || '',
      sent: false, expired: false, done: false, error: null, busy: false, stopWatching: null,
    };
  },
  methods: {
    t,
    // Done elsewhere (e.g. the emailed link opened in another tab or on another device): go on if
    // this browser is signed in, otherwise say so and offer sign-in.
    alreadyDone() {
      if (this.$store.state.user) this.$router.replace({ name: 'list' });
      else this.done = true;
    },
    reset() {
      Object.assign(this, { id: null, code: '', sent: false, expired: false, done: false, error: null });
    },
    async run(action) {
      this.error = null;
      this.busy = true;
      try {
        await action();
      } catch (e) {
        const code = e.msg || String(e);
        if (code === 'already-done') this.alreadyDone();
        else if (code === 'expired') this.expired = true;
        else this.error = errorText(code);
      } finally {
        this.busy = false;
      }
    },
    send() {
      return this.run(async () => {
        this.id = await auth.requestPasswordReset(this.email);
        this.sent = true;
      });
    },
    setPassword() {
      if (this.password !== this.password2) { this.error = t('error-passwords-differ'); return; }
      return this.run(async () => {
        await auth.verifyPasswordReset(this.id, this.code.trim(), this.password);
        this.$router.replace({ name: 'list' });
      });
    },
  },
  mounted() {
    // While waiting for the code, follow a sign-in in another tab (the emailed link).
    this.stopWatching = auth.watchOtherTabs(() => this.$router.replace({ name: 'list' }));
  },
  beforeDestroy() {
    if (this.stopWatching) this.stopWatching();
  },
};
</script>

<style src="./auth.css"></style>
